import { RouteKey } from "./types";

// Mirrors the paths in routesAuthenticated.tsx. Used only as a fallback
// target when a route is blocked for the current provider, so ProviderRoute
// can land on *some* allowed route instead of assuming "dashboard" is
// always reachable.
export const ROUTE_PATHS: Record<RouteKey, string> = {
  dashboard: "/main/dashboard/overview",
  automations: "/main/automations/overview",
  campaigns: "/main/campaigns/overview/future-campaigns",
  calendar: "/main/campaigns/calendar",
  forms: "/main/forms",
  audience: "/main/audience",
  workflows: "/main/workflows",
  "onboarding.plan-selection": "/onboarding/plan-selection",
  "onboarding.brand-voice": "/onboarding/brand-voice",
  "account-settings.ai-tuning": "/main/account-settings/ai-tuning",
  "account-settings.profile": "/main/account-settings/profile",
  "account-settings.plans": "/main/account-settings/plans",
  "account-settings.sender-details": "/main/account-settings/sender-details",
  "account-settings.brand-kit": "/main/account-settings/brand-kit",
  "account-settings.hero-image": "/main/account-settings/hero-image",
  "account-settings.dns": "/main/account-settings/verify-dns-settings",
};
